// Manifesto as a Side A / Lado B card. See sections/pr-manifesto.liquid and assets/pr-manifesto.css.
// - Turns the two stacked faces into one card that flips; the face that is down is inert.
// - The two side buttons (aria-pressed) and a click or tap on the card itself flip it.
// - Also shows a random pick of the sign-off countries on every page load (the page itself is cached).
(() => {
  document.querySelectorAll('[data-pr-countries]').forEach((el) => {
    const all = el.dataset.prCountries.split(',').filter(Boolean);
    const count = Number(el.dataset.prCount) || all.length;
    for (let i = all.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [all[i], all[j]] = [all[j], all[i]];
    }
    el.textContent = all.slice(0, count).join(' – ');
  });

  document.querySelectorAll('[data-pr-sideb]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    const card = root.querySelector('[data-pr-sideb-card]');
    const faces = [...root.querySelectorAll('[data-pr-sideb-face]')];
    const buttons = [...root.querySelectorAll('[data-pr-sideb-side]')];
    if (!card || faces.length < 2) return;

    const show = (side, turning) => {
      if (turning) root.classList.add('is-turning'); // transitions only once the visitor flips it
      root.dataset.face = side;
      faces.forEach((face) => {
        face.inert = face.dataset.prSidebFace !== side;
      });
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.prSidebSide === side)));
    };

    root.classList.add('is-flippable');
    root.querySelector('[data-pr-sideb-switch]')?.removeAttribute('hidden');
    root.querySelector('[data-pr-sideb-hint]')?.removeAttribute('hidden');
    show(root.dataset.face === 'b' ? 'b' : 'a', false);

    buttons.forEach((button) => button.addEventListener('click', () => show(button.dataset.prSidebSide, true)));
    card.addEventListener('click', (event) => {
      if (event.target.closest('a, button')) return;
      if (String(window.getSelection?.() || '').trim()) return; // selecting text is not a flip
      show(root.dataset.face === 'b' ? 'a' : 'b', true);
    });
  });
})();
